// Single source of truth for store details — every CTA on the site reads from here.
export const SITE = {
  name: "Om Sri Sri Collection",
  phoneDisplay: "+91 88252 82510",
  phoneRaw: "+918825282510",
  whatsapp: "918825282510",
  addressLine1: "Ashram Kitchen Road, Udayapura",
  addressLine2: "Kanakapura Main Road, Bangalore – 560082",
  addressFull:
    "Ashram Kitchen Road, Udayapura, Kanakapura Main Road, Bangalore - 560082",
  hours: "Open daily · 8:00 AM – 10:00 PM",
  hoursShort: "8 AM – 10 PM, all days",
  locality: "Udayapura, Kanakapura Road",
  city: "Bangalore",
};

const MAPS_QUERY = encodeURIComponent(
  `Om Sri Sri Collection, ${SITE.addressFull}`
);
SITE.mapsUrl = `https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`;
SITE.mapsEmbedUrl = `https://www.google.com/maps?q=${MAPS_QUERY}&z=16&output=embed`;

// Google Business Profile Place ID — when set, the review button opens the
// "write a review" dialog directly. Until then it opens our Google Maps listing.
SITE.googlePlaceId = "";
SITE.reviewUrl = SITE.googlePlaceId
  ? `https://search.google.com/local/writereview?placeid=${SITE.googlePlaceId}`
  : SITE.mapsUrl;

// Languages spoken in-store (order as provided by the owner).
export const LANGUAGES = [
  { name: "Hindi", native: "हिन्दी", font: "font-devanagari" },
  { name: "Kannada", native: "ಕನ್ನಡ", font: "font-kannada" },
  { name: "English", native: "English", font: "font-display italic" },
  { name: "Rajasthani", native: "राजस्थानी", font: "font-devanagari" },
  { name: "Haryanvi", native: "हरियाणवी", font: "font-devanagari" },
];

// "Welcome" in every official (Eighth Schedule) language of India + English, Rajasthani & Haryanvi.
export const GREETINGS = [
  { name: "Hindi", greet: "स्वागत है", font: "font-devanagari" },
  { name: "Kannada", greet: "ಸ್ವಾಗತ", font: "font-kannada" },
  { name: "English", greet: "Welcome", font: "font-display italic" },
  { name: "Rajasthani", greet: "पधारो सा", font: "font-devanagari" },
  { name: "Haryanvi", greet: "राम राम जी", font: "font-devanagari" },
  { name: "Bengali", greet: "স্বাগতম", font: "font-bengali" },
  { name: "Telugu", greet: "స్వాగతం", font: "font-telugu" },
  { name: "Marathi", greet: "स्वागत आहे", font: "font-devanagari" },
  { name: "Tamil", greet: "வணக்கம்", font: "font-tamil" },
  { name: "Urdu", greet: "خوش آمدید", font: "font-arabic", rtl: true },
  { name: "Gujarati", greet: "સ્વાગત છે", font: "font-gujarati" },
  { name: "Odia", greet: "ସ୍ୱାଗତ", font: "font-odia" },
  { name: "Malayalam", greet: "സ്വാഗതം", font: "font-malayalam" },
  { name: "Punjabi", greet: "ਜੀ ਆਇਆਂ ਨੂੰ", font: "font-gurmukhi" },
  { name: "Assamese", greet: "স্বাগতম", font: "font-bengali" },
  { name: "Maithili", greet: "स्वागत अछि", font: "font-devanagari" },
  { name: "Santali", greet: "ᱡᱚᱦᱟᱨ", font: "font-olchiki" },
  { name: "Kashmiri", greet: "خوش آمدید", font: "font-arabic", rtl: true },
  { name: "Nepali", greet: "स्वागत छ", font: "font-devanagari" },
  { name: "Sindhi", greet: "ڀلي ڪري آيا", font: "font-arabic", rtl: true },
  { name: "Konkani", greet: "येवकार", font: "font-devanagari" },
  { name: "Dogri", greet: "जी आया नूं", font: "font-devanagari" },
  { name: "Manipuri", greet: "ꯇꯔꯥꯝꯅ ꯑꯣꯛꯆꯔꯤ", font: "font-meetei" },
  { name: "Bodo", greet: "स्वागत", font: "font-devanagari" },
  { name: "Sanskrit", greet: "स्वागतम्", font: "font-devanagari" },
];

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;

export const telLink = `tel:${SITE.phoneRaw}`;

export const WA = {
  general:
    "Hello Om Sri Sri Collection, I would like to know more about your products/services.",
  delivery:
    "Hello, I would like to place an order for delivery. My location is ______.",
  alteration:
    "Hello Om Sri Sri Collection, I would like to ask about your boutique & alteration services.",
  category: (name) =>
    `Hello Om Sri Sri Collection, I would like to know more about your ${name} collection.`,
};

// Real store photography (owner-supplied, professionally retouched).
export const STORE_PHOTOS = {
  kurtis: "/images/store-kurtis.jpg",
  interior: "/images/store-interior-v5.jpg",
  bags: "/images/store-bags.jpg",
  sportsBag: "/images/store-sports-bag.jpg",
};

export const IMAGES = {
  heroMain: STORE_PHOTOS.interior,
  heroKurtis: STORE_PHOTOS.kurtis,
  heroBags: STORE_PHOTOS.bags,
  ladies: STORE_PHOTOS.kurtis,
  gents: "/images/gents-wear.jpg",
  footwear:
    "https://images.unsplash.com/photo-1559766084-38c917374a9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
  innerwear:
    "https://images.pexels.com/photos/5746100/pexels-photo-5746100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bags: STORE_PHOTOS.bags,
  accessories:
    "https://images.unsplash.com/photo-1626508651395-474256aba3ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
  boutique:
    "https://images.unsplash.com/photo-1673201229733-69d19c5c4a87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100&auto=format",
  home:
    "https://images.unsplash.com/photo-1601276174812-63280a55656e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
  family:
    "https://images.unsplash.com/photo-1567966320762-6393bda044d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100&auto=format",
  kids:
    "https://images.unsplash.com/photo-1630329273801-8f629dba0a72?crop=entropy&cs=srgb&fm=jpg&q=85&w=800&auto=format",
  saree:
    "https://images.unsplash.com/photo-1588140686379-1b76a52103dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800&auto=format",
  sandals:
    "https://images.pexels.com/photos/97048/pexels-photo-97048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
